import { render, staticRenderFns } from "./NovoDynamicForm.vue?vue&type=template&id=60174b27&"
import script from "./NovoDynamicForm.vue?vue&type=script&lang=js&"
export * from "./NovoDynamicForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports